import { render } from "./ViewSettings.vue?vue&type=template&id=708bfab8&scoped=true"
import script from "./ViewSettings.vue?vue&type=script&lang=js"
export * from "./ViewSettings.vue?vue&type=script&lang=js"

import "./ViewSettings.vue?vue&type=style&index=0&id=708bfab8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708bfab8"]])

export default __exports__